import { WelcomeContentComponent } from './welcome-content/welcome-content.component';
import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatListItem, MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatToolbarModule } from '@angular/material/toolbar';
import { Router, RouterModule } from '@angular/router';
import { RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module } from 'ng-recaptcha';
import { environment } from '../../../environments/environment';


@Component({
  selector: 'app-welcome',
  standalone: true,
  imports: [
    MatToolbarModule,
    MatIconModule,
    MatButtonModule,
    MatListModule,
    MatMenuModule,
    RouterModule,
    RecaptchaV3Module,
    WelcomeContentComponent,
  ],
  template: `
    <mat-toolbar>
      <div class="mat-toolbar-content">
        <div class="column-full-space" [routerLink]="['index']">
          <img src="./assets/images/logo.png" class="logo">
        </div>
        <!-- <button mat-button>PAQUETES DE SERVICIOS</button> -->
        <button mat-button class="show-desktop" [routerLink]="['contact-pqr']">REPORTAR PQR</button>
        <button mat-button class="show-desktop" [routerLink]="['contact']">CONTACTAR</button>
        <button mat-button class="show-desktop" color="primary" (click)="gotoSignin()">ENTRAR</button>
        <button mat-button matIconButton [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu" class="show-mobile">
          <mat-icon>menu</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
          <button [routerLink]="['/contact-pqr']" mat-menu-item routerLinkActive="active-link">
            <span>REPORTAR PQR</span>
          </button>
          <button mat-menu-item [routerLink]="['/contact']">
            <span>CONTACTAR</span>
          </button>
          <button mat-menu-item (click)="gotoSignin()">
            <span>ENTRAR</span>
          </button>
        </mat-menu>
      </div>
    </mat-toolbar>
    <div id='stars'></div>
    <div id='stars2'></div>
    <div id='stars3'></div>
    <app-welcome-content></app-welcome-content>
  `,
  styleUrls: ['./welcome.component.css']
})
export class WelcomeComponent {
  snav: any
  url: string = '';
  constructor(
    private router: Router
  ) {
    this.url = `${environment.protocol}://${environment.appHost}/`;
  }
  gotoSignin() {
    window.open(this.url);
  }
}
